import { API, Helpers, Router } from '../Helpers';
import { NextArrow, PrevArrow, ReviewRating } from '../Shared';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Select from 'react-select';
import Slider from "react-slick";

export default class ToursCarousel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            cart: this.props.data.cart,
            location: _.find(this.props.data.locations.data, (_location) => { return _location.slug == this.props.data.payload.location; }),
            tours: this.props.data.tours,
            sort_by: this.props.data.sort_by,
            specific_tours: this.props.data.specific_tours || false
        };
        
        this.changeLocation = this.changeLocation.bind(this);
        this.changeSortBy = this.changeSortBy.bind(this);
        this.findProductCoverPhoto = this.findProductCoverPhoto.bind(this);
        this.findTourListingCtaText = this.findTourListingCtaText.bind(this);
        this.generateProductUrl = this.generateProductUrl.bind(this);
        this.getLocationOptions = this.getLocationOptions.bind(this);
        this.inCart = this.inCart.bind(this);
        this.nextCount = this.nextCount.bind(this);
        this.showLoader = this.showLoader.bind(this);
        this.loadMoreTours = this.loadMoreTours.bind(this);
        this.toCount = this.toCount.bind(this);
        this.urlParams = this.urlParams.bind(this);
    }
    
    changeLocation(location)
    {
        //console.log("changeLocation", location);
        
        this.setState({
            location: location
        }, () => {
            this.updateTours();
        });
    }
    
    changeSortBy(sort_by)
    {
        this.setState({
            sort_by: sort_by
        }, () => 
        {
            this.updateTours();
        });
    }
    
    findProductCoverPhoto(tour)
    {
        if (!_.isEmpty(tour.cover_photo))
        {
            return tour.cover_photo.medium;
        }
        
        return '/images/placeholder-16-9.jpg';
    }
    
    findTourListingCtaText()
    {
        let tour_listing_cta_text = _.find(this.props.data.active_site.settings.data, (_setting) => { return _setting.key == 'tour_listing_cta_text'; });
        
        if (!_.isEmpty(tour_listing_cta_text))
        {
            return tour_listing_cta_text.value;
        }
    }
    
    generateProductUrl(tour)
    {
        const router = Router(this.props.data.routes);
        
        let params = {
            domain: this.props.data.active_site.domain, 
            id: tour.id, 
            tour_slug: tour.slug
        };
        
        if (!_.isEmpty(this.state.location) )
        {
            if (!_.isEmpty(this.state.location.region_slug) && !_.isNull(this.state.location.region_slug))
            {
                params.region_slug = this.state.location.region_slug;

                if (!_.isEmpty(this.state.location.country_slug) && !_.isNull(this.state.location.country_slug))
                {
                    params.country_slug = this.state.location.country_slug;

                    return this.state.specific_tours ? router.url("specific_tours.show_region", params) : router.url('tours.show_region', params);
                }
            }
            
            if (!_.isEmpty(this.state.location.country_slug) && !_.isNull(this.state.location.country_slug))
            {
                params.country_slug = this.state.location.country_slug;
                
                return this.state.specific_tours ? router.url("specific_tours.show_country", params) : router.url('tours.show_country', params);
            }            
           
        }        
        
        return this.state.specific_tours ? router.url("specific_tours.show", params) : router.url('tours.show', params);
    }
    
    getLocationOptions()
    {
        let location_options = [];
        
        _.forEach(this.props.data.locations.data, (location) => {
            
            location.label = location.name;
            location.value = location.slug;
            
            location_options.push(location);
        });
        
        return _.sortBy(location_options, ['label']);
    }
    
    inCart(tour)
    {
        let index = _.findIndex(this.state.cart.items, (_item) => { return tour.name == _item.name; });
        
        if (index > -1)
        {
            return true;
        }
        
        return false;
    }
    
    nextCount()
    {
        if ((this.state.tours.meta.pagination.total - (this.state.tours.meta.pagination.current_page * this.state.tours.meta.pagination.per_page)) < this.state.tours.meta.pagination.per_page)
        {
            return this.state.tours.meta.pagination.total - this.state.tours.meta.pagination.current_page * this.state.tours.meta.pagination.per_page;
        }
        
        return this.state.tours.meta.pagination.per_page;
    }
    
    showLoader()
    {
        //console.log("showLoader");
        
        this.setState({
            show_loader: true
        });
    }
    
    loadMoreTours(page)
    {
        //console.log("loadMoreTours");
        
        const router = Router(this.props.data.routes);
        
        let payload = this.urlParams(page);
        
        //console.log("payload", payload);
        
        let onResponse = {
            success: (response) => 
            {
                //console.log("loadMoreTours response", response);
                
                let tours = {...this.state.tours};
                
                tours.data = tours.data.concat(response.data);
                tours.meta = response.meta;
                
                this.setState({
                    tours: tours,
                    loading_more_tours: false
                });
            },
            error: error => 
            {
                console.log('error', error);
            },
            complete: () => 
            {
                console.log('complete');
            }
        }
        
        this.setState({
            loading_more_tours: true
        }, () => 
        {
            API.get(onResponse, router.url('api.tours.index', payload));
        });
    }
    
    updateTours()
    {
        //console.log("updateTours");
        
        const router = Router(this.props.data.routes);
        
        let payload = this.urlParams();
        
        //console.log("payload", payload);
        
        let onResponse = {
            success: (response) => 
            {
                //console.log("updateTours response", response);
                
                this.setState({
                    tours: response,
                    show_loader: false
                });
            },
            error: error => 
            {
                console.log('error', error);
            },
            complete: () => 
            {
                console.log('complete');
            }
        }
        
        this.setState({
            show_loader: true
        }, () => 
        {
            API.get(onResponse, router.url('api.tours.index', payload));
        });
    }
    
    toCount()
    {
        return this.state.tours.meta.pagination.current_page * this.state.tours.meta.pagination.per_page < this.state.tours.meta.pagination.total ? this.state.tours.meta.pagination.current_page * this.state.tours.meta.pagination.per_page : this.state.tours.meta.pagination.total;
    }
    
    urlParams(page)
    {
        let params = _.omit(this.props.data.payload, ['location', 'sort_by']);
        
        params = _.assign({ sort_by: this.state.sort_by.slug }, params);
        
        if (!_.isEmpty(this.state.location))
        {
            params = _.assign({ location: this.state.location.slug }, params);
        }
        
        if (page > 1)
        {
            params = _.assign({ page: page }, params);
        }
        
        return params;
    }
        
    render() {
        
        const { active_site, locations, order_by_options, request, routes } = this.props.data;
        const router = Router(routes);
        const tour_listing_cta_text = this.findTourListingCtaText();
        
        return (
            <div>
                <div className="row d-none">
                    <div className="col-12">
                        <div className="form-group">
                            <Select 
                                options={this.getLocationOptions()} 
                                onChange={(value) => {this.changeLocation(value)}}
                                value={!_.isEmpty(this.state.location) ? this.state.location : ''}
                                placeholder="Choose your destination..."
                                styles={{
                                    control: (provided, state) => ({
                                    ...provided,
                                    padding: '0.5rem'
                                  })
                                }}
                            />
                        </div>
                    </div>
                </div>

                {
                    !_.isEmpty(this.state.tours.data) &&
                    <div className="row mb-9">
                        <div className="col-12">
                                <Slider {...{
                                    className: "slick-carousel h-100",
                                    infinite: true,
                                    initialSlide: 0,
                                    slidesToShow: this.state.tours.data.length >= 3 ? 3 : 2,
                                    slidesToScroll: 1,
                                    prevArrow: <PrevArrow />,
                                    nextArrow: <NextArrow />,
                                    responsive: [
                                        {
                                            breakpoint: 1200,
                                            settings: {
                                                slidesToShow: this.state.tours.data.length >= 3 ? 3 : 2,
                                                slidesToScroll: 1
                                            }
                                        },
                                        {
                                            breakpoint: 1024,
                                            settings: {
                                                arrows: false,
                                                centerMode: true,
                                                centerPadding: '20px',
                                                slidesToShow: 2,
                                                slidesToScroll: 1
                                            }
                                        },
                                        {
                                            breakpoint: 768,
                                            settings: {
                                                arrows: false,
                                                centerMode: true,
                                                centerPadding: '20px',
                                                slidesToShow: 1,
                                                slidesToScroll: 1
                                            }
                                        }
                                    ]
                                }}>

                                {
                                    this.state.tours.data.map((tour, key) => {

                                        const product_url = this.generateProductUrl(tour);
                                        const product_cover_photo = this.findProductCoverPhoto(tour);

                                        return (
                                            <div key={key} className="position-relative h-100">
                                                <a href={product_url} className="d-flex h-100">
                                                    <div className="card rounded-0 border">
                                                        <div className="card-image overflow-hidden position-relative">
                                                            <img className="img-fluid" src={product_cover_photo} />

                                                            {
                                                                this.inCart(tour) &&
                                                                <div className="position-absolute card z-depth-0 border-black" style={{ top: '10px', right: '10px' }} tabIndex="0">
                                                                    <div className="card-body text-center p-2 black primary-text">
                                                                        <i className="fa fa-shopping-cart mr-2"></i><i className="fa fa-check"></i>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>

                                                        <div className="card-body border-top-0 position-relative">
                                                            {
                                                                !_.isEmpty(tour.address) &&
                                                                <div><span className="body-text-color font-smaller text-uppercase truncate-1">{tour.address}</span></div>
                                                            }

                                                            <ReviewRating 
                                                                star_rating={!_.isNull(tour.average_rating) ? tour.average_rating : 0}
                                                                count={tour.reviews_count}
                                                            />

                                                            <h4 className="three-b-text font-weight-bold body-font mb-3 truncate-2 d-none d-lg-webkit-box">
                                                                {tour.name}
                                                            </h4>

                                                            <h5 className="three-b-text font-weight-bold body-font mb-3 truncate-2 d-lg-none">
                                                                {tour.name}
                                                            </h5>
                                                        </div>

                                                        { 
                                                            !_.isEmpty(tour_listing_cta_text) &&
                                                            <div className="card-footer white p-2">
                                                                <div className="text-right">
                                                                    <button className="btn btn-link primary-text">{tour_listing_cta_text}<i className="fa fa-angle-right ml-2"></i></button>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </a>
                                            </div>
                                        )
                                    })
                                }
                                </Slider>
                        </div>
                    </div>
                }

                {
                    this.state.show_loader &&
                    <div className="view viewport-height position-fixed three-b opacity-75 w-100 z-max" style={{ left: 0, top: 0, bottom: 0, right: 0 }}>
                        <div className="progress md-progress primary-color z-3 mb-0">
                            <div className="indeterminate"></div>
                        </div>

                        <div className="mask d-flex justify-content-center align-items-center">
                            <div className="preloader-wrapper active crazy">
                                <div className="spinner-layer spinner-red-only spinner-primary">
                                    <div className="circle-clipper left">
                                        <div className="circle"></div>
                                    </div>
                                    <div className="gap-patch">
                                        <div className="circle"></div>
                                    </div>
                                    <div className="circle-clipper right">
                                        <div className="circle"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

if (document.getElementById('toursCarousel')) {
    
    const element = document.getElementById('toursCarousel');
    const data = Object.assign({}, element.dataset);
        
    //console.log(data.data);
    
    ReactDOM.render(<ToursCarousel data={JSON.parse(data.data)} />, document.getElementById('toursCarousel'));
}



// WEBPACK FOOTER //
// ./resources/js/components/Shortcodes/ToursCarousel.js